import script from "./ContentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentPage.vue?vue&type=script&setup=true&lang=js"

import "./ContentPage.vue?vue&type=style&index=0&id=462a21e3&lang=scss"

const __exports__ = script;

export default __exports__